import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { ReactComponent as Logo } from "assets/icons/LogoLight.svg";
import { ReactComponent as ArrowLeftIcon } from "assets/icons/SideBarLeftArrow.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/SidebarDownArrow.svg";
import { ReactComponent as CollapseLogo } from "assets/icons/collapseLogo.svg";
import { ReactComponent as SideBarIcon } from "assets/icons/SideBarNew.svg";
import { AppProviderTypes } from "components/AppProvider/AppProvider.props";
import { ReactComponent as SideBarClose } from "assets/icons/sidebarClose.svg";
import { GlobalContext } from "components/AppProvider";
import { SidebarProps } from "./Sidebar.props";
import Icons from "./Icons";
import "./style.scss";

const Sidebar = React.memo<SidebarProps>(
    ({ routes, notCollapseView = false }) => {
        const { pathname } = useLocation();
        const { push } = useHistory();
        const [listItem, setListItem] = useState<string>();
        const [states, setStates] = useContext(GlobalContext);
        const ref = useRef<any>(null);

        useEffect(() => {
            const sideBar = localStorage.getItem("sideBarPref");
            if (
                !!sideBar &&
                sideBar !== "null" &&
                sideBar !== "undefined" &&
                !notCollapseView
            ) {
                setStates((prv: AppProviderTypes) => ({
                    ...prv,
                    sidebarPref: JSON.parse(sideBar),
                }));
            } else {
                setStates((prv: AppProviderTypes) => ({
                    ...prv,
                    sidebarPref: false,
                }));
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setListItem("");
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);

        useEffect(() => {
            localStorage.setItem(
                "sideBarPref",
                JSON.stringify(states.sidebarPref)
            );
            setListItem("");
        }, [states.sidebarPref]);
        if (
            pathname !== "/financial-period-list" &&
            !pathname.includes("/financial-sale-report") &&
            !pathname.includes("/financial-demand-report") &&
            !pathname.includes("/financial-payment-report") &&
            !pathname.includes("/add-new-payment") &&
            !pathname.includes("/financial-discount-report")
        ) {
            localStorage.removeItem("periodId");
            localStorage.removeItem("vendorId");
            localStorage.removeItem("financialPeriodId");
            localStorage.removeItem("financialPeriodDate");
            localStorage.removeItem("financialVendorId");
        }

        return (
            <nav
                className={`sidebar ${
                    states.sidebarPref ? "collapse-view" : ""
                }`}
                data-testid="sidebar"
                ref={ref}
            >
                <div className="text-center logo-container">
                    {states.sidebarPref ? (
                        <CollapseLogo />
                    ) : (
                        <Logo className="logo" />
                    )}
                    {!notCollapseView ? (
                        states.sidebarPref ? (
                            <SideBarIcon
                                className={
                                    states.sidebarPref
                                        ? "side-bar-collapse"
                                        : "side-bar-toggle"
                                }
                                onClick={() => {
                                    setStates((prv: AppProviderTypes) => ({
                                        ...prv,
                                        sidebarPref: !states.sidebarPref,
                                    }));
                                }}
                            />
                        ) : (
                            <SideBarClose
                                className={
                                    states.sidebarPref
                                        ? "side-bar-collapse"
                                        : "side-bar-toggle"
                                }
                                onClick={() => {
                                    setStates((prv: AppProviderTypes) => ({
                                        ...prv,
                                        sidebarPref: !states.sidebarPref,
                                    }));
                                }}
                            />
                        )
                    ) : null}
                </div>
                <div className="mt-3">
                    {routes?.map((route, index) => {
                        return (
                            <div className="routes-container" key={index}>
                                <div
                                    className="nav-title"
                                    onClick={() => {
                                        if (listItem === route.title) {
                                            setListItem("");
                                        } else {
                                            setListItem(route.title);
                                        }
                                    }}
                                >
                                    {Icons.map((item) => {
                                        if (item.title === route.title) {
                                            return (
                                                <item.Icon className="icons ml-2" />
                                            );
                                        } else {
                                            return null;
                                        }
                                    })}
                                    {!states.sidebarPref && route.title}
                                    {!states.sidebarPref && (
                                        <div className="mr-auto">
                                            {route.title === listItem ? (
                                                <ArrowIcon />
                                            ) : (
                                                <ArrowLeftIcon />
                                            )}
                                        </div>
                                    )}
                                </div>
                                {route.title === listItem &&
                                    states.sidebarPref && (
                                        <div className="collapse-menu-tooltip">
                                            {route.subRoutes.map((subRoute) => (
                                                <h6
                                                    className={`toggle-nav-link ${
                                                        subRoute.isHide
                                                            ? "isHide"
                                                            : ""
                                                    } ${
                                                        pathname.includes(
                                                            subRoute.group
                                                        )
                                                            ? "toggle-active"
                                                            : ""
                                                    }`}
                                                    key={subRoute.key}
                                                    data-testid="subRoutes"
                                                    onClick={() => {
                                                        setListItem(" ");
                                                        push(subRoute.path);
                                                    }}
                                                >
                                                    {subRoute.name}
                                                </h6>
                                            ))}
                                        </div>
                                    )}
                                <Collapse
                                    in={
                                        route.title === listItem ||
                                        (!states.sidebarPref &&
                                            route.subRoutes.some(
                                                (el) => pathname === el.path
                                            ))
                                    }
                                >
                                    <div>
                                        {route.subRoutes.map((subRoute) => (
                                            <Link
                                                className={` nav-link ${
                                                    subRoute.isHide
                                                        ? "isHide"
                                                        : ""
                                                } ${
                                                    pathname.includes(
                                                        subRoute.group
                                                    )
                                                        ? "active"
                                                        : ""
                                                }`}
                                                key={subRoute.key}
                                                data-testid="subRoutes"
                                                to={subRoute.path}
                                            >
                                                {!states.sidebarPref
                                                    ? subRoute.name
                                                    : "       "}
                                            </Link>
                                        ))}
                                    </div>
                                </Collapse>
                            </div>
                        );
                    })}
                </div>
            </nav>
        );
    }
);

export default Sidebar;
